import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "field__widget" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "required-mark"
}
const _hoisted_4 = { class: "select__container" }
const _hoisted_5 = ["name", "value", "onChange"]
const _hoisted_6 = ["value"]
const _hoisted_7 = ["name"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", {
  value: undefined,
  selected: ""
}, " Chargement ... ", -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "select__triangle" }, null, -1)


import {
    ChoiceMultiplePrioritizedConfig,
    NULL_VALUE_UID,
    PrioritizedValue,
} from "../forms";

type AllowedValues = { key: number | string; value: string }[] | null;


export default /*#__PURE__*/_defineComponent({
  props: {
    value: null,
    config: null,
    allowedValues: null
  },
  emits: ["update:value"],
  setup(__props: any, { emit }: { emit: ({
    (e: "update:value", v: PrioritizedValue): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    value: PrioritizedValue;
    config: ChoiceMultiplePrioritizedConfig;
    allowedValues: AllowedValues;
}





function getAllowedValues(
    values: AllowedValues,
    selectIndex: number
): AllowedValues {
    if (props.config.allowSame) return values;
    if (values === null) return null;
    const selected = props.value.map((v) => v[props.config.column]);
    return values.filter(
        (v) =>
            (props.value.length > selectIndex &&
                props.value[selectIndex][props.config.column] === v.key) ||
            !selected.includes(
                typeof v.key === "number" ? v.key : parseInt(v.key)
            )
    );
}

function selectValue(i: number, evt: Event) {
    const selectEl = evt.target as HTMLSelectElement;
    const value = selectEl.value;

    const arr = props.value;
    if (arr.length < i) {
        throw "Cannot set value for this index";
    }
    const e: PrioritizedValue[keyof PrioritizedValue] = {
        priority: i,
        [props.config.column]:
            typeof value === "number" ? value : parseInt(value),
    };
    if (arr.length === i) {
        arr.push(e);
    } else {
        arr[i] = e;
    }
    emit("update:value", arr);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.config.count, (i) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
        (i - 1 <= __props.value.length)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (__props.value.length > 0)
                ? (_openBlock(), _createElementBlock("label", _hoisted_2, [
                    _createTextVNode(_toDisplayString(__props.config.singularLabel) + " " + _toDisplayString(i), 1),
                    (i === 1 && __props.config.markAsRequired === true)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3, " *"))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_4, [
                (__props.allowedValues != null)
                  ? (_openBlock(), _createElementBlock("select", {
                      key: 0,
                      name: __props.config.name,
                      value: 
                            __props.value.length > i - 1
                                ? __props.value[i - 1][__props.config.column]
                                : undefined
                        ,
                      onChange: (e) => selectValue(i - 1, e)
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getAllowedValues(
                                __props.allowedValues,
                                i - 1
                            ), ({ key, value }, index) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: index,
                          value: 
                                typeof key === 'string' ? parseInt(key) : key
                            
                        }, _toDisplayString(value === _unref(NULL_VALUE_UID) ? "" : value), 9, _hoisted_6))
                      }), 128))
                    ], 40, _hoisted_5))
                  : (_openBlock(), _createElementBlock("select", {
                      key: 1,
                      name: __props.config.name
                    }, _hoisted_9, 8, _hoisted_7)),
                _hoisted_10
              ])
            ], 64))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}
}

})